<template>
    <!-- 整体容器 -->
    <div class="vipaper-container">
        <!-- 顶部导航栏 -->
        <header class="vipaper-header">
            <button class="back-btn">×</button>
            <div class="paper-title">
                <h1>VIPaper</h1>
                <p>www.vipaper.com</p>
            </div>
            <button class="share-btn">...</button>
        </header>

        <!-- 论文基础信息区 -->
        <section class="paper-basic">
            <h2 class="paper-title-main">用于组学解释的深度学习与大语言模型混合工作流</h2>
            <p class="paper-title-en">A deep learning and large language model hybrid workflow for omics interpretation</p>
            <div class="paper-source">
                <span>Journal of Biomedical Engineering</span>
            </div>
            <div class="paper-authors">
                <span class="author-tag">Shao Tang</span>
                <span class="author-tag">Chi Zhang</span>
                <span class="author-tag">Weizhi Zhang</span>
                <span class="author-tag">Yu Xue</span>
                <button class="show-more-authors">显示全部</button>
            </div>
        </section>

        <!-- 摘要区 -->
        <section class="paper-abstract">
            <h3>摘要</h3>
            <p>从海量组学数据中剖析分子全景图可以识别细胞中的调控网络，但这需要机制性解释和实验跟进。本研究结合深度学习和大语言模型推理，开发了一个用于组学解释的混合工作流，命名为LyMOI。LyMOI整合了GPT-3.5用于生物知识推理，以及一个结合图卷积网络的大图模型。该大图模型整合了进化保守的蛋白质相互作用，并使用分层微调从多组学数据中预测特定情境下的分子调控因子。GPT-3.5随后生成机器思维链，机制性地解释它们在生物系统中的作用。聚焦于自噬，LyMOI机制性地解释了1.3 TB的转录组、蛋白质组和磷酸化蛋白质组数据，并扩展了对自噬调控因子的认知。我们还发现LyMOI突出了两种人类癌蛋白CTSL和FAM98，它们能在抗肿瘤剂双硫仑处理下增强自噬。在体外沉默这些基因可减弱双硫仑介导的自噬并抑制癌细胞增殖。引人注目的是，使用先前用于预防SARS-CoV-2感染的CTSL特异性抑制剂Z-FY-CHO与双硫仑联合处理，能在体内有效抑制肿瘤生长。</p>
        </section>

        <!-- 功能按钮区 -->
        <section class="paper-actions">
            <button class="action-btn primary">📄 全文拆解</button>
            <button class="action-btn secondary">🎥 视频讲解</button>
        </section>

        <!-- 折叠要点区（参考热心肠） -->
        <section class="paper-points">
            <div class="collapse-item">
                <div class="collapse-header">
                    <span>▶ 要点总结</span>
                </div>
                <div class="collapse-content">
                    <!-- 要点内容 -->
                </div>
            </div>
            <div class="collapse-item">
                <div class="collapse-header">
                    <span>▶ 研究方法</span>
                </div>
                <div class="collapse-content">
                    <!-- 方法内容 -->
                </div>
            </div>
            <div class="collapse-item">
                <div class="collapse-header">
                    <span>▶ 关键创新点</span>
                </div>
                <div class="collapse-content">
                    <!-- 创新点内容 -->
                </div>
            </div>
            <div class="collapse-item">
                <div class="collapse-header">
                    <span>▶ 局限性</span>
                </div>
                <div class="collapse-content">
                    <!-- 局限性内容 -->
                </div>
            </div>
        </section>

        <!-- 提问区 -->
        <section class="paper-qa">
            <div class="qa-input">
                <input type="text" placeholder="输入问题提问" />
                <button class="qa-submit">➤</button>
            </div>
            <p class="qa-tip">注：每个问题消耗2积分，<a href="#">查看我的积分</a></p>
        </section>

        <!-- 音频字幕区（参考一卒听库） -->
        <section class="paper-audio">
            <div class="audio-player">
                <button class="voice-btn">🔊 Voice paper</button>
                <span class="audio-time">00:00 / 00:00</span>
                <button class="play-btn">▶</button>
            </div>
            <!-- 字幕浮层 -->
            <div class="subtitle-panel">
                <div class="subtitle-header">
                    <button class="play-btn">▶ 播放</button>
                    <button class="close-subtitle">×</button>
                </div>
                <div class="subtitle-content">
                    <p>1.今天的内容是一个关于组学数据解读的新方法，研究人员通过整合深度学习和大语言模型，开发出了一个能够自动化解读组学数据，并能够帮助我们发现新的分子调控机制以及药物靶点的工具。</p>
                </div>
                <div class="audio-progress">
                    <div class="progress-bar" style="width: 7%;"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
    // // 折叠面板交互
    // const collapseHeaders = document.querySelectorAll('.collapse-header');
    // collapseHeaders.forEach(header => {
    //     header.addEventListener('click', () => {
    //         const item = header.parentElement;
    //         item.classList.toggle('active');
    //         // 切换箭头
    //         header.querySelector('span').textContent = item.classList.contains('active') ? '▼ 要点总结' : '▶ 要点总结';
    //     });
    // });
    //
    // // 音频字幕播放控制
    // const playBtn = document.querySelector('.play-btn');
    // const subtitlePanel = document.querySelector('.subtitle-panel');
    // let isPlaying = false;
    //
    // playBtn.addEventListener('click', () => {
    //     isPlaying = !isPlaying;
    //     playBtn.textContent = isPlaying ? '⏸' : '▶';
    //     // 模拟音频播放与字幕同步
    //     if (isPlaying) {
    //         subtitlePanel.style.display = 'block';
    //         // 这里可接入音频播放器API，同步更新进度条与字幕内容
    //     } else {
    //         subtitlePanel.style.display = 'none';
    //     }
    // });
</script>

<style scoped>
    /* 基础重置 */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    }

    .vipaper-container {
        max-width: 100%;
        min-height: 100vh;
        background: #fff;
        padding: 0 16px;
    }

    /* 顶部导航 */
    .vipaper-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #eee;
    }
    .paper-title {
        text-align: center;
    }
    .paper-title h1 {
        font-size: 18px;
        font-weight: 600;
    }
    .paper-title p {
        font-size: 12px;
        color: #666;
    }

    /* 论文基础信息 */
    .paper-basic {
        margin: 16px 0;
    }
    .paper-title-main {
        font-size: 20px;
        font-weight: 700;
        line-height: 1.4;
        margin-bottom: 8px;
    }
    .paper-title-en {
        font-size: 14px;
        color: #333;
        margin-bottom: 12px;
    }
    .paper-authors {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
    }
    .author-tag {
        padding: 4px 8px;
        background: #f0f5ff;
        border-radius: 4px;
        font-size: 13px;
        color: #165dff;
    }
    .show-more-authors {
        font-size: 13px;
        color: #165dff;
        background: none;
        border: none;
    }

    /* 摘要 */
    .paper-abstract {
        margin: 20px 0;
    }
    .paper-abstract h3 {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 8px;
    }
    .paper-abstract p {
        font-size: 15px;
        line-height: 1.6;
        color: #333;
    }

    /* 功能按钮 */
    .paper-actions {
        display: flex;
        gap: 12px;
        margin: 20px 0;
    }
    .action-btn {
        flex: 1;
        padding: 10px 0;
        border-radius: 8px;
        border: none;
        font-size: 15px;
        font-weight: 500;
    }
    .action-btn.primary {
        background: #165dff;
        color: #fff;
    }
    .action-btn.secondary {
        background: #f5f7fa;
        color: #333;
    }

    /* 折叠要点 */
    .collapse-item {
        border-bottom: 1px solid #eee;
    }
    .collapse-header {
        padding: 12px 0;
        font-size: 15px;
        font-weight: 500;
        color: #165dff;
        cursor: pointer;
    }
    .collapse-content {
        padding: 0 0 12px 20px;
        font-size: 14px;
        line-height: 1.5;
        color: #666;
        display: none; /* 默认折叠 */
    }
    .collapse-item.active .collapse-content {
        display: block;
    }

    /* 提问区 */
    .paper-qa {
        margin: 20px 0;
    }
    .qa-input {
        display: flex;
        align-items: center;
        border: 1px solid #eee;
        border-radius: 8px;
        padding: 8px 12px;
    }
    .qa-input input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;
    }
    .qa-submit {
        background: none;
        border: none;
        color: #165dff;
        font-size: 18px;
    }
    .qa-tip {
        font-size: 12px;
        color: #999;
        margin-top: 8px;
    }

    /* 音频与字幕 */
    .paper-audio {
        position: relative;
    }
    .audio-player {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
    }
    .voice-btn {
        background: none;
        border: none;
        font-size: 14px;
        color: #333;
    }
    .audio-time {
        font-size: 13px;
        color: #666;
    }
    .play-btn {
        background: #165dff;
        color: #fff;
        border: none;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .subtitle-panel {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
        padding: 12px 16px;
        z-index: 100;
    }
    .subtitle-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .subtitle-content {
        font-size: 14px;
        line-height: 1.5;
        color: #333;
        margin-bottom: 12px;
    }
    .audio-progress {
        height: 4px;
        background: #eee;
        border-radius: 2px;
    }
    .progress-bar {
        height: 100%;
        background: #165dff;
        border-radius: 2px;
    }
</style>